import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const ConsultationModal = ({ isOpen, onClose, onSubmit, initialData }) => {
  const [form, setForm] = useState({
    patient_name: "",
    patient_id: "",
    age: "",
    markdown: "",
    doctor_report: "",
  });

  useEffect(() => {
    if (initialData) {
      const consultation = initialData.consultations?.[0] || {};
      setForm({
        patient_name: consultation.markdown
          ? consultation.markdown.split("\n")[2]?.replace("- Name: ", "")
          : "",
        patient_id: initialData.patient_id || "",
        age: consultation.markdown
          ? consultation.markdown.split("\n")[3]?.replace("- Age: ", "")
          : "",
        markdown: consultation.markdown || "",
        doctor_report: consultation.doctor_report || "",
      });
    }
  }, [initialData]);

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-[#00254D] rounded-xl w-11/12 max-w-md max-h-[90vh] p-6 relative overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 dark:text-white hover:bg-gray-200 rounded-full"
        >
          <X size={20} />
        </button>

        <h2 className="text-xl dark:text-white font-semibold mb-4">
          {initialData ? "Edit" : "Add"} Patient Consultation
        </h2>

        <form className="space-y-3" onSubmit={handleSubmit}>
          <input
            placeholder="Patient Name"
            value={form.patient_name}
            onChange={(e) => handleChange("patient_name", e.target.value)}
            className="w-full p-2 border rounded-lg"
            required
          />
          <input
            placeholder="Patient ID"
            value={form.patient_id}
            onChange={(e) => handleChange("patient_id", e.target.value)}
            className="w-full p-2 border rounded-lg"
            required
          />
          <input
            placeholder="Age"
            type="number"
            value={form.age}
            onChange={(e) => handleChange("age", e.target.value)}
            className="w-full p-2 border rounded-lg"
            required
          />
          <textarea
            placeholder="Consultation Notes / Markdown"
            value={form.markdown}
            onChange={(e) => handleChange("markdown", e.target.value)}
            className="w-full p-2 border rounded-lg h-32"
          />
          <textarea
            placeholder="Doctor Report"
            value={form.doctor_report}
            onChange={(e) => handleChange("doctor_report", e.target.value)}
            className="w-full p-2 border rounded-lg h-20"
          />

          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 dark:text-white rounded-lg border"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConsultationModal;
